"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = useEnsureDeploymentIds;
var _react = require("react");
var _reactRedux = require("react-redux");
var _admin = require("../reducers/admin.js");
var _admin2 = require("../selectors/admin.js");
function useEnsureDeploymentIds() {
  var dispatch = (0, _reactRedux.useDispatch)();
  var deployments = (0, _reactRedux.useSelector)(function (state) {
    return (0, _admin2.getCurrentAssignmentDeployments)(state.assignment.admin);
  });
  var deploymentIds = (0, _reactRedux.useSelector)(function (state) {
    return (0, _admin2.getCurrentDeploymentIds)(state.assignment.admin);
  });
  (0, _react.useEffect)(function () {
    function ensureDeployment() {
      if (!deploymentIds.length && deployments && deployments.length) {
        dispatch((0, _admin.setCurrentDeploymentIds)([deployments[0].deploymentId]));
        dispatch((0, _admin.setSelectedDeploymentIds)([deployments[0].deploymentId]));
      }
    }
    ensureDeployment();
  }, [deployments]);
}